// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"898cb605","455":"31a408d8","644":"0ea70ebd"}[chunkId] + ".chunk.js";
};